export default __webpack_public_path__ + "media/titles/title_4_locale_nl-76ba86a8.png";